<script>
import CardContacto from "./CardContacto.vue";
// import IconContacto from "./IconContacto.vue";
//import PreguntasFrecuentes from "../Noticias y Frecuentes/PreguntasFrecuentes.vue";
export default {
	async mounted() {
		await this.$store.dispatch("getPreguntasFrecuentes");
		// await this.$store.dispatch("getIconContacto");
	},
	components: {
		CardContacto,
		//PreguntasFrecuentes,
		// IconContacto,
	},
	computed: {
		// IconosContacto() {
		//   return this.$store.getters.icon_contacto;
		// },
		PreguntasFrecuentes() {
			return this.$store.getters.preguntas_frecuentes;
		},
	},
};
</script>

<template>
	<section class="divider parallax section-contacto">
		<div class="container-fluid p-0">
			<div class="row">
				<CardContacto class="col-md-4" />
				<div class="col-md-4">
					<div class="div-mapas mb-2">
						<h3 class="mt-0 line-height-1">
							SEDE
							<span class="text-theme-colored"> CABA</span>
						</h3>
						<p class="p-direccion">Adolfo Alsina 1163</p>

						<div
							id="accordeon-home-preguntas-frecuentes"
							class="panel-group accordion"
						>
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.7383304270575!2d-58.38537302494312!3d-34.61077775786986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccad08309808b%3A0xc5c8dd08dcd31bdd!2sAdolfo%20Alsina%201163%2C%20C1088AAE%20Cdad.%20Aut%C3%B3noma%20de%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1719429652302!5m2!1ses!2sar"
								width="600"
								height="50%"
								style="border: 0"
								allowfullscreen=""
								loading="lazy"
								referrerpolicy="no-referrer-when-downgrade"
							></iframe>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="div-mapas">
						<h3 class="mt-0 line-height-1">
							SEDE
							<span class="text-theme-colored">MONTE GRANDE</span>
						</h3>
						<p class="p-direccion">Tomás Edison 2300</p>

						<div
							id="accordeon-home-preguntas-frecuentes"
							class="panel-group accordion"
						>
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13101.22660722432!2d-58.49789000091178!3d-34.823381711135276!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcd1109d05bc13%3A0x9269f2528e78511!2sPOA%20Monte%20Grande!5e0!3m2!1ses-419!2sar!4v1720108086741!5m2!1ses-419!2sar"
								width="600"
								height="50%"
								style="border: 0"
								allowfullscreen=""
								loading="lazy"
								referrerpolicy="no-referrer-when-downgrade"
							></iframe>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
.row {
	padding: 1rem;
}

@media (orientation: portrait) {
	.row {
		gap: 8rem;
	}
}

.div-mapas {
	height: 100%;
	width: 100%;
}

.div-mapas > div {
	height: 100%;
	width: 100%;
}

.div-mapas > div > iframe {
	height: 100%;
	width: 100%;
}

h3 {
	font-size: 1.75em;
}

.p-direccion {
	font-size: 1.2em;
}

.bg-preguntas-frecuentes > div {
	padding: 15px !important;
}

@media (min-width: 576px) {
	.bg-preguntas-frecuentes > div {
		padding: 15px !important;
	}
}

@media (min-width: 768px) {
	.bg-preguntas-frecuentes > div {
		padding: 15px !important;
	}

	/* .div-mapas {
		height: 50%;
	} */
}
</style>
